import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20filled%20with%20fans%20dramatic%20stadium%20lights%20at%20night%20abstract%20artistic%20style%20with%20motion%20blur%20effects%20orange%20and%20warm%20tones%20energetic%20atmosphere%20professional%20sports%20photography%20style%20epic%20scale&width=1800&height=900&seq=hero-sports-bg&orientation=landscape)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
        <div className="inline-flex items-center gap-2 bg-primary-500/90 text-white px-4 py-1.5 rounded-full text-xs font-medium mb-6">
          <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
          12场赛事正在直播中
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight max-w-4xl">
          极速体育——
          <span className="text-primary-400">实时赛事直播</span>
          与体育资讯平台
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl leading-relaxed">
          足球、篮球、网球等全项目覆盖，极速体育让你零延迟感受每一个精彩瞬间，随时随地掌握赛场动态
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/football"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观看直播
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white rounded-full text-sm font-semibold hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap border border-white/20"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center">
          <div className="w-1.5 h-1.5 bg-white rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}